<div class="tech-team">
    <div class="tech-team-sidebar">
        <cx-page-slot position="Section2B"></cx-page-slot>
    </div>
    <div class="tech-team-root">
        <h1 class="bendix-techteam-headling m-0">Bendix Tech Team</h1>
        <div class="tech-team-container">
            <div class="tech-team-left-item">
                <cx-page-slot position="Section3"></cx-page-slot>
            </div>
            <div class="tech-team-right-item">
                <cx-page-slot position="Section2A"></cx-page-slot>
            </div>
        </div>
    </div>
</div>